"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9654],{

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ LandingWhiteSec; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kj": function() { return /* binding */ LandingGreySecWrap; },
/* harmony export */   "zq": function() { return /* binding */ LandingGreySec; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__Flex",
  componentId: "sc-1i94ptm-0"
})(["display:flex;align-items:center;"]);
var LandingGreySec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySec",
  componentId: "sc-1i94ptm-1"
})(["background:#f5f5f5;padding:", ";margin-top:-120px;margin-bottom:", ";@media only screen and (max-width:768px){padding:", ";margin-top:", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.padding || "16px";
}, function (props) {
  return props.marginTop || "0px";
});
var LandingGreySecWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySecWrap",
  componentId: "sc-1i94ptm-2"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingWhiteSec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingWhiteSec",
  componentId: "sc-1i94ptm-3"
})(["width:1200px;margin:0 auto;background:#fff;padding:", ";@media only screen and (max-width:768px){width:100%;padding:16px;}"], function (props) {
  return props.padding;
});

/***/ }),

/***/ 907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ BulletList; }
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/BulletList/index.style.ts


var UnorderedList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "indexstyle__UnorderedList",
  componentId: "sc-1kwyvbg-0"
})(["font-weight:400;font-size:18px;line-height:32px;padding-left:18px;gap:10px;margin-bottom:12px;& li{position:relative;}& li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:8px;background:", ";border-radius:14px;}& .yellowText{background:linear-gradient(86.88deg,", " 0%,", " 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:600;}& .greenText{background:linear-gradient(93.66deg,", " 0%,", " 100%),", ";-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:600;}& .bold{background:linear-gradient(0deg,", ",", "),linear-gradient(93.66deg,", " 0%,", " 100%),", ";-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:600;}}"], function (props) {
  return props.bulletColor;
}, colors/* GRADIENT_COLOR.metallicSunBurst */.oi.metallicSunBurst, colors/* GRADIENT_COLOR.mustardYellow */.oi.mustardYellow, colors/* GRADIENT_COLOR.celladonGreen */.oi.celladonGreen, colors/* GRADIENT_COLOR.seaGreen */.oi.seaGreen, colors/* GRADIENT_COLOR.white */.oi.white, colors/* GRADIENT_COLOR.black */.oi.black, colors/* GRADIENT_COLOR.black */.oi.black, colors/* GRADIENT_COLOR.celladonGreen */.oi.celladonGreen, colors/* GRADIENT_COLOR.seaGreen */.oi.seaGreen, colors/* GRADIENT_COLOR.white */.oi.white);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/BulletList/index.tsx


var BulletList = function BulletList(_ref) {
  var list = _ref.list,
      bulletColor = _ref.bulletColor,
      flexDirection = _ref.flexDirection,
      gap = _ref.gap;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(UnorderedList, {
    bulletColor: bulletColor,
    flexDirection: flexDirection,
    gap: gap,
    children: list === null || list === void 0 ? void 0 : list.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        dangerouslySetInnerHTML: {
          __html: item
        }
      }, index);
    })
  });
};

/***/ }),

/***/ 8607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ CustomerEngagement; }
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingButton/LandingButton.tsx + 1 modules
var LandingButton = __webpack_require__(1893);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/pincode/index.tsx + 3 modules
var pincode = __webpack_require__(5702);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/customerEngagement/index.style.ts


var LandingCurrDelTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "indexstyle__LandingCurrDelTitle",
  componentId: "sc-1om6dqc-0"
})(["font-family:\"Raleway\";font-style:normal;font-weight:500;font-size:48px;line-height:64px;color:", ";margin-bottom:32px;width:600px;"], colors/* TEXT_COLOR.high */.ou.high);
var LandingCurrDelInfo = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelInfo",
  componentId: "sc-1om6dqc-1"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:22px;line-height:30px;color:", ";margin-bottom:24px;& .bold{font-weight:700;}"], colors/* TEXT_COLOR.medium */.ou.medium);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/customerEngagement/index.tsx








var CustomerEngagement = function CustomerEngagement(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      deliveryInfo = _ref.deliveryInfo,
      load = _ref.load,
      buyCtaText = _ref.buyCtaText,
      buyRedirectionUrl = _ref.buyRedirectionUrl,
      verifyPincodeCtaText = _ref.verifyPincodeCtaText,
      onClick = _ref.onClick,
      offering = _ref.offering,
      events = _ref.events,
      defaultDeliveryDays = _ref.defaultDeliveryDays;
  var router = (0,next_router.useRouter)();

  var _ref2 = events || {},
      buyNowEvent = _ref2.buyNowEvent,
      checkPincodeEvent = _ref2.checkPincodeEvent,
      multiCurrencyLinkEvent = _ref2.multiCurrencyLinkEvent;

  var onClickBuy = function onClickBuy(e) {
    if (buyNowEvent) (0,analytics/* pushEvent */.AB)(buyNowEvent);
    if (buyRedirectionUrl) router.push(buyRedirectionUrl);

    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  var onClickMultiCurrencyLink = function onClickMultiCurrencyLink() {
    if (multiCurrencyLinkEvent) {
      (0,analytics/* pushEvent */.AB)(multiCurrencyLinkEvent);
    }
  };

  var AnchorComponent = function AnchorComponent(_ref3) {
    var href = _ref3.href,
        children = _ref3.children;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      onClick: onClickMultiCurrencyLink,
      children: children[0]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDelTitle, {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDelInfo, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
        components: {
          a: AnchorComponent
        },
        children: subtitle ? subtitle : ""
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
      margin: "0 0 40px",
      customTitle: buyCtaText,
      handleClick: onClickBuy,
      padding: "12px 40px"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pincode/* Pincode */.u, {
      text: deliveryInfo,
      load: load,
      ctaText: verifyPincodeCtaText,
      offering: offering,
      defaultDeliveryDays: defaultDeliveryDays,
      onClick: function onClick(pincode) {
        if (checkPincodeEvent !== null && checkPincodeEvent !== void 0 && checkPincodeEvent.cta) {
          checkPincodeEvent.cta.pincode = pincode;
          (0,analytics/* pushEvent */.AB)(checkPincodeEvent);
        }
      }
    })]
  });
};

/***/ }),

/***/ 8741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Markdown; },
  "Y": function() { return /* binding */ PlainMarkdown; }
});

// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/markdown/styled.ts

var StyledMarkdown = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledMarkdown",
  componentId: "sc-61ko64-0"
})(["line-height:1.4;margin-top:15px;p,ol{margin:1em 0;&:last-child{margin-bottom:0;}&:first-child{margin-top:0;}}li{margin:0.5em 0;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/markdown/index.tsx



var Markdown = function Markdown(_ref) {
  var children = _ref.children,
      _ref$resetStyles = _ref.resetStyles,
      resetStyles = _ref$resetStyles === void 0 ? false : _ref$resetStyles;
  var content = children ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
    children: children
  }) : null;
  return resetStyles ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMarkdown, {
    children: content
  }) : content;
};
var PlainMarkdown = function PlainMarkdown(_ref2) {
  var children = _ref2.children,
      _ref2$resetStyles = _ref2.resetStyles,
      resetStyles = _ref2$resetStyles === void 0 ? true : _ref2$resetStyles;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Markdown, {
    resetStyles: resetStyles,
    children: children
  });
};

/***/ }),

/***/ 5702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Pincode; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Loader/index.style.ts

var Loader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__Loader",
  componentId: "zj21t7-0"
})(["border:3px solid #f3f3f3;border-top:3px solid black;border-radius:50%;width:28px;height:28px;animation:spin 1s linear infinite;@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/pincode/index.style.ts


var LandingCurrDelCity = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelCity",
  componentId: "sc-17hn3j7-0"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:18px;line-height:32px;color:", ";position:relative;margin-bottom:8px;&:after{content:\"\";position:absolute;background:", ";border-radius:15px;width:40px;height:4px;top:-4px;left:0;}em{color:", ";margin-bottom:8px;font-weight:700;font-style:normal;}"], colors/* TEXT_COLOR.medium */.ou.medium, colors/* BG_COLOR.lightSilver */.VR.lightSilver, colors/* TEXT_COLOR.illuminatingEmerald */.ou.illuminatingEmerald);
var CheckBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "indexstyle__CheckBtn",
  componentId: "sc-17hn3j7-1"
})(["background:", ";box-shadow:0px 1px 7px ", ";border-radius:6px;font-weight:900;font-size:16px;line-height:20px;color:", ";outline:none;border:none;cursor:pointer;width:102px;height:40px;flex-shrink:0;display:flex;align-items:center;justify-content:center;"], colors/* BG_COLOR.white */.VR.white, colors/* BLACK_COLOR.21 */.wC[21], colors/* TEXT_COLOR.high */.ou.high);
var ErrorText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__ErrorText",
  componentId: "sc-17hn3j7-2"
})(["margin-top:8px;font-family:\"Open Sans\";font-size:12px;line-height:16px;color:#eb2026;"]);
var DeliveryText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "indexstyle__DeliveryText",
  componentId: "sc-17hn3j7-3"
})(["color:#22936a;font-weight:bold;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/usePincode/index.ts
var usePincode = __webpack_require__(7184);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 9 modules
var src = __webpack_require__(5537);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useCheckValidPincode/index.ts





var AREA_TYPE;

(function (AREA_TYPE) {
  AREA_TYPE["SERVICABLE"] = "SEVICABLE";
  AREA_TYPE["NON_SERVICABLE"] = "NON_SERVICABLE";
})(AREA_TYPE || (AREA_TYPE = {}));

var isPincodeInList = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var pincodes, inputPincode;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pincodes = _ref.pincodes, inputPincode = _ref.inputPincode;
            return _context.abrupt("return", new Promise(function (resolve) {
              if (inputPincode) {
                inputPincode = +inputPincode;

                if (pincodes !== null && pincodes !== void 0 && pincodes.includes(inputPincode)) {
                  resolve(true);
                }
              }

              resolve(false);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isPincodeInList(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var isPincodeNotInList = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
    var pincodes, inputPincode;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            pincodes = _ref3.pincodes, inputPincode = _ref3.inputPincode;
            return _context2.abrupt("return", new Promise(function (resolve) {
              if (inputPincode) {
                inputPincode = +inputPincode;

                if (!(pincodes !== null && pincodes !== void 0 && pincodes.includes(inputPincode))) {
                  resolve(true);
                }
              }

              resolve(false);
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function isPincodeNotInList(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var isValidPincode = function isValidPincode(area_type) {
  if (area_type === AREA_TYPE.SERVICABLE) {
    return isPincodeInList;
  } else if (area_type === AREA_TYPE.NON_SERVICABLE) {
    return isPincodeNotInList;
  }

  return null;
};

var useCheckValidPincode = function useCheckValidPincode(offering) {
  var _pincodeData$pin_code;

  var _useState = (0,react.useState)(false),
      checkingPincode = _useState[0],
      setCheckingPinCode = _useState[1];

  var _usePincode = (0,usePincode/* usePincode */.d)(),
      pincodeData = _usePincode.pincodeData,
      deliveryEstimateData = _usePincode.deliveryEstimateData;

  var pincodeObj = pincodeData === null || pincodeData === void 0 ? void 0 : (_pincodeData$pin_code = pincodeData.pin_codes_info) === null || _pincodeData$pin_code === void 0 ? void 0 : _pincodeData$pin_code.find(function (obj) {
    return obj.offering === offering;
  });
  var pincodes = (pincodeObj === null || pincodeObj === void 0 ? void 0 : pincodeObj.codes) || [];

  var checkPincodeHandler = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(inputPincode) {
      var _isValidPincode;

      var regex, isValid;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              regex = /^[1-9][0-9]{5}$/;

              if (inputPincode !== null && inputPincode !== void 0 && inputPincode.match(regex)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", null);

            case 3:
              setCheckingPinCode(true);
              _context3.next = 6;
              return (_isValidPincode = isValidPincode(pincodeObj === null || pincodeObj === void 0 ? void 0 : pincodeObj.area_type)) === null || _isValidPincode === void 0 ? void 0 : _isValidPincode({
                pincodes: pincodes,
                inputPincode: inputPincode
              });

            case 6:
              isValid = _context3.sent;
              setCheckingPinCode(false);
              return _context3.abrupt("return", isValid);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function checkPincodeHandler(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var getDeliveryDate = function getDeliveryDate(pincode, defaultDeliveryDays) {
    var count;

    if (offering === "INR") {
      count = deliveryEstimateData[pincode || ""] || defaultDeliveryDays.INR;
    } else {
      count = defaultDeliveryDays.BMF;
    }

    return (0,src/* getFutureDate */.O8)(count);
  };

  return {
    checkingPincode: checkingPincode,
    checkPincodeHandler: checkPincodeHandler,
    getDeliveryDate: getDeliveryDate
  };
};

/* harmony default export */ var hooks_useCheckValidPincode = (useCheckValidPincode);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/markdown/index.tsx + 1 modules
var markdown = __webpack_require__(8741);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/pincode/index.tsx











var Pincode = function Pincode(_ref) {
  var text = _ref.text,
      ctaText = _ref.ctaText,
      onClick = _ref.onClick,
      offering = _ref.offering,
      defaultDeliveryDays = _ref.defaultDeliveryDays;

  var _useState = (0,react.useState)(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var _useState2 = (0,react.useState)(null),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      inputPincode = _useState3[0],
      setInputPincode = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isValidPin = _useState4[0],
      setIsValidPin = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      validPincodeData = _useState5[0],
      setValidPincodeData = _useState5[1];

  var _useCheckValidPincode = hooks_useCheckValidPincode(offering),
      checkingPincode = _useCheckValidPincode.checkingPincode,
      checkPincodeHandler = _useCheckValidPincode.checkPincodeHandler,
      getDeliveryDate = _useCheckValidPincode.getDeliveryDate;

  var _useState6 = (0,react.useState)({}),
      _useState6$ = _useState6[0],
      date = _useState6$.date,
      suffix = _useState6$.suffix,
      monthName = _useState6$.monthName,
      setDeliveryDate = _useState6[1];

  var pincodeInputRef = (0,react.useRef)(null);

  var pincodeCheckHanlder = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event) {
      var _pincodeInputRef$curr, _isValidPin, _pincodeInputRef$curr2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (typeof onClick === "function" && inputPincode) {
                onClick(inputPincode);
              }

              if (!(!inputPincode || (inputPincode === null || inputPincode === void 0 ? void 0 : inputPincode.trimEnd()) === "")) {
                _context.next = 7;
                break;
              }

              setError("Pincode can not be blank");
              setIsValidPin(false);
              (_pincodeInputRef$curr = pincodeInputRef.current) === null || _pincodeInputRef$curr === void 0 ? void 0 : _pincodeInputRef$curr.focus();
              _context.next = 11;
              break;

            case 7:
              _context.next = 9;
              return checkPincodeHandler(inputPincode);

            case 9:
              _isValidPin = _context.sent;

              if (_isValidPin) {
                setIsValidPin(true);
                setValidPincodeData(inputPincode);
                setError(null);
                setDeliveryDate(getDeliveryDate(inputPincode, defaultDeliveryDays));
              } else {
                if (_isValidPin === null) {
                  setError("Invalid pincode, kindly enter a valid pincode");
                } else {
                  setError("Sorry, we don't deliver to this pincode");
                }

                setIsValidPin(false);
                (_pincodeInputRef$curr2 = pincodeInputRef.current) === null || _pincodeInputRef$curr2 === void 0 ? void 0 : _pincodeInputRef$curr2.focus();
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function pincodeCheckHanlder(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var pincodeChangeHandler = function pincodeChangeHandler(e) {
    setInputPincode(e.target.value);
    setError("");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isValidPin ? /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDelCity, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(markdown/* Markdown */.U, {
        children: text
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDelCity, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Delivery to Pincode ", validPincodeData, " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(DeliveryText, {
          children: [" ", "by ", date, /*#__PURE__*/(0,jsx_runtime.jsx)("sup", {
            children: suffix
          }), " ", monthName, " "]
        })]
      })
    }), text && /*#__PURE__*/(0,jsx_runtime.jsxs)(shared_styled_components/* Flex */.kC, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        inputMode: "numeric",
        className: "".concat(checkingPincode ? "disable" : "", " ").concat(error ? "error" : focus ? "focus" : ""),
        placeholder: "ENTER PINCODE",
        onChange: pincodeChangeHandler,
        ref: pincodeInputRef,
        onFocus: function onFocus() {
          return setFocus(true);
        },
        onBlur: function onBlur() {
          return setFocus(false);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBtn, {
        onClick: pincodeCheckHanlder,
        children: checkingPincode ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader, {}) : ctaText
      })]
    }), error && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorText, {
      className: "errorText",
      children: error
    })]
  });
};

/***/ }),

/***/ 6609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ PoweredByText; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2193);


var PoweredByText = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].span.withConfig({
  displayName: "indexstyle__PoweredByText",
  componentId: "sc-2q0mg3-0"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:12px;line-height:16px;color:", ";margin-right:20px;"], _tm_utility_theme__WEBPACK_IMPORTED_MODULE_0__/* .TEXT_COLOR.high */ .ou.high);

/***/ })

}]);